<div class="search-wrapper" [pTooltip]="tooltipText" tooltipPosition="top" [tooltipDisabled]="!tooltipText">
  <i class="fas fa-search"></i>
  <input
    type="text"
    [ngModel]="searchTerm()"
    (ngModelChange)="searchTerm.set($event)"
    placeholder="Search..." />
</div>